function contactForm() {
    var form = document.getElementById("contactForm");
    if (!form) return;

    var alert = document.getElementById("contactFormAlert");
    var submitBtn = document.getElementById("contactSubmitBtn");
    var csrfToken = document.querySelector('meta[name="csrf-token"]');
    var siteKey = submitBtn.dataset.sitekey;

    form.addEventListener("submit", function (e) {
        e.preventDefault();

        submitBtn.disabled = true;

        grecaptcha.ready(function () {
            grecaptcha
                .execute(siteKey, { action: "contact" })
                .then(function (token) {
                    document.getElementById("recaptchaToken").value = token;

                    var formData = new FormData(form);

                    fetch(form.action, {
                        method: "POST",
                        headers: {
                            "X-Requested-With": "XMLHttpRequest",
                            "X-CSRF-TOKEN": csrfToken ? csrfToken.content : "",
                            Accept: "application/json",
                        },
                        body: formData,
                    })
                        .then(function (response) {
                            return response.json().then(function (data) {
                                return { ok: response.ok, data: data };
                            });
                        })
                        .then(function (result) {
                            alert.classList.remove("is-hidden", "alert-success", "alert-error");

                            if (result.ok && result.data.success) {
                                alert.classList.add("alert-success");
                                alert.textContent = result.data.message;
                                form.reset();
                            } else {
                                alert.classList.add("alert-error");
                                if (result.data.errors) {
                                    var messages = [];
                                    Object.keys(result.data.errors).forEach(function (key) {
                                        messages.push(result.data.errors[key][0]);
                                    });
                                    alert.textContent = messages.join(" ");
                                } else {
                                    alert.textContent = result.data.message;
                                }
                            }

                            submitBtn.disabled = false;
                        })
                        .catch(function () {
                            alert.classList.remove("is-hidden", "alert-success", "alert-error");
                            alert.classList.add("alert-error");
                            alert.textContent = form.dataset.errorMessage || "An error occurred. Please try again.";
                            submitBtn.disabled = false;
                        });
                });
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    contactForm();
});
